import React from 'react';
import './machine_css.css';
import { ReactComponent as PlusSign } from '../Icons/Plus_sign.svg';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router';
import { cartAnimation } from './items/animation';
// import logger from '../services/LocalServer/logger';
import { currencyStyle } from '../services/methods';
import { currencyOptions } from '../staticData/options';

export default function MachineProductsCard(props) {
  const { products, i, setShowp, setmyprod, langs, symbol, mainL, plus } = props;
  const today = new Date();
  const { t } = useTranslation();
  let history = useHistory();

  const Fname =
    products[i].name[langs] && products[i].name[langs] !== ''
      ? products[i].name[langs]
      : products[i].name?.en;

  const Bname =
    products[i].brand?.name[langs] && products[i].brand?.name[langs] !== ''
      ? products[i].brand?.name[langs]
      : products[i].brand?.name?.en;

  let allBuyXproducts = '';
  let count = 0;
  if (products[i].promoIndex) {
    products.forEach((e, index) => {
      if (e.promoIndex === products[i].promoIndex) {
        count++;
        if (e.name[langs] && e.name[langs] !== '') {
          allBuyXproducts += e.name[langs];
        } else {
          allBuyXproducts += e.name?.en;
        }
        if (index !== products.length - 1) {
          allBuyXproducts += ', ';
        }
      }
    });
    if (count > 1) {
      allBuyXproducts = allBuyXproducts.substring(0, allBuyXproducts.length - 2);
    }
    console.log(count);

    console.log('allBuyXproducts', allBuyXproducts);
  }

  if (props.nextPurchase) {
    const codePromo = JSON.parse(localStorage.getItem('promo'));
    codePromo.forEach((ele) => {
      if (ele._id === products[i].promo) {
        ele.product?.forEach((e, index) => {
          if (e.name[langs] && e.name[langs] !== '') {
            allBuyXproducts += e.name[langs];
          } else {
            allBuyXproducts += e.name?.en;
          }
          if (index !== ele.product.length - 1) {
            allBuyXproducts += ', ';
          }
        });
      }
    });
  }

  const showModal = (e, details) => {
    Swal.fire({
      title: ' ',
      html: details,
      showCloseButton: true,
      showConfirmButton: false,
    });
    if (!e) var e = window.event;
    e.cancelBubble = true;
    if (e.stopPropagation) e.stopPropagation();
  };

  function calculateItemPrice() {
    if (props.nextPurchase) {
      let details = `<p class="card-product-title"><span style="color: red;">`;
      if (props.percentage) {
        details += `${t('Get')}  ${props.amount * 100}% ${t('off')} ${t(
          'on your next purchase!'
        )}(${allBuyXproducts})`;
      } else {
        details += `${t('Get')} ${currencyStyle(
          langs,
          symbol,
          props.amount.toLocaleString(mainL, currencyOptions)
        )} ${t('Off')} ${t('on your next purchase')}(${allBuyXproducts})`;
      }

      return (
        <div>
          {' '}
          <span
            style={{ margin: 0, color: 'red', textDecoration: 'underline dotted' }}
            onClick={(e) => showModal(e, details)}
          >
            {<h4 className="ribbon"> {t('SALE')}</h4>}
          </span>
        </div>
      );
    }

    if (props.buyX) {
      if (props.percentage) {
        const details = `<p class="card-product-title"><span style="color: red;">${t(
          'Buy'
        ).toUpperCase()} ${props.buyX} ${t('Or').toUpperCase()} ${t(
          'More'
        ).toUpperCase()} ${allBuyXproducts}, ${t('Get').toUpperCase()} ${props.amount * 100}% ${t(
          'Off'
        ).toUpperCase()}! </span></p>`;
        return (
          <div>
            <span style={{ margin: 0 }}>
              {currencyStyle(langs, symbol, props.price.toLocaleString(mainL, currencyOptions))}
            </span>
            &nbsp;&nbsp;{' '}
            <span
              style={{ margin: 0, color: 'red', textDecoration: 'underline dotted' }}
              onClick={(e) => showModal(e, details)}
            >
              {<h4 className="ribbon"> {t('SALE')}</h4>}
            </span>
          </div>
        );
      } else {
        const details = `<p class="card-product-title"><span style="color: red;">${t(
          'Buy'
        ).toUpperCase()} ${props.buyX} ${t('Or').toUpperCase()} ${t(
          'More'
        ).toUpperCase()} ${allBuyXproducts}, ${t('Get').toUpperCase()} ${currencyStyle(
          langs,
          symbol,
          props.amount.toLocaleString(mainL, currencyOptions)
        )} ${t('Off').toUpperCase()}! </span></p>`;
        return (
          <div>
            <span style={{ margin: 0 }}>
              {currencyStyle(langs, symbol, props.price.toLocaleString(mainL, currencyOptions))}
            </span>
            &nbsp;&nbsp;{' '}
            <span
              style={{ margin: 0, color: 'red', textDecoration: 'underline dotted' }}
              onClick={(e) => showModal(e, details)}
            >
              {<h4 className="ribbon"> {t('SALE')}</h4>}
            </span>
          </div>
        );

        // return <span>${props.price} - <span style={{color: 'red'}}>{t('Promo')}!</span></span>
      }
    } else if (props.discountedPrice) {
      return (
        <div>
          <span>
            <del>
              {currencyStyle(langs, symbol, props.price.toLocaleString(mainL, currencyOptions))}
            </del>

            <span style={{ color: 'red', marginLeft: '5px' }}>
              &nbsp;&nbsp;
              {currencyStyle(
                langs,
                symbol,
                props.discountedPrice.toLocaleString(mainL, currencyOptions)
              )}
            </span>
          </span>
        </div>
      );
    } else {
      return (
        <div className="product_card_price">
          {currencyStyle(langs, symbol, props.price.toLocaleString(mainL, currencyOptions))}
        </div>
      );
    }
  }

  const addToCart = async (e) => {
    const index = props.cart?.findIndex((item) => item.id === products[i]._id);
    if (props.prod.current_stock > 0) {
      props.decreStock(products[i], products[i].current_stock - 1);
      if (
        props.prod.plan &&
        Date.parse(props.prod.plan.start) <= today &&
        Date.parse(props.prod.plan.end) >= today
      ) {
        setShowp(true);
        setmyprod(props.prod);
      }
      if (index >= 0) {
        // logger(2, `1 more ${Fname} has been added to cart`);
        props.alterquantity({ id: products[i]._id }, props.cart[index].quantity + 1);
      } else {
        // logger(2, `${Fname} has been added to cart`);
        props.add({
          idx: parseInt(i),
          id: products[i]._id,
          key: products[i]._id,
          _id: products[i]._id,
          upc: products[i]?.upc,
          title: products[i].name,
          name: products[i].name,
          promo: products[i].promo,
          price: products[i].price,
          discount: products[i].discount ? products[i].discount : 0,
          percentage: products[i].percentage,
          discountedPrice: products[i].discountedPrice
            ? products[i].discountedPrice
            : products[i].price,
          image: products[i].productPictures[0],
          buyX: products[i].buyX ? products[i].buyX : 0,
          quantity: 1,
          category: products[i].category,
          ingredients: products[i].ingredients,
          referTo: products[i].referTo,
          prodType: products[i].prodType,
          current_stock: products[i].current_stock,
          emailCode: products[i].emailCode,
          promoIndex: products[i].promoIndex,
          nextPurchase: products[i].nextPurchase,
          tax_type: products[i].tax_type,
        });
      }
    }
  };
  return props.column === '3' ? (
    <div>
      <div
        className="mb-5 ml-1 mr-1 category-card"
        style={{
          paddingLeft: '15px',
          paddingRight: '15px',
          boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)',
          overflow: 'hidden',
          position: 'relative',
          height: '290px',
        }}
      >
        {products[i].current_stock == 0 && (
          <div
            className="out_of_stock_container"
            onClick={() => history.push(`/machineUI/product/${props.machineID}/${props.id}/${i}`)}
          >
            <div className="category-card out_of_stock_div"></div>
            <div className="out_of_stock_text d-flex flex-column justify-content-center align-items-center">
              <p style={{ marginBottom: '-10px' }}>{t(`Out of`)}</p>
              <p>{t(`Stock`)}</p>
            </div>
          </div>
        )}
        {/* <div className="d-flex"> */}
        <div
          onClick={() => history.push(`/machineUI/product/${props.machineID}/${props.id}/${i}`)}
          style={{
            textDecoration: 'none',
            color: 'inherit',
          }}
        >
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              height: '170px',
              border: 'none',
              borderRadius: '1em',
              borderBottom: 'none',
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
            }}
          >
            <img
              style={{
                maxHeight: '80%',
                maxWidth: '90%',
              }}
              src={props.image}
              alt={props.imagename}
            />
          </div>
          <div
            style={{
              paddingBottom: '0',
              paddingTop: '0.5rem',
            }}
            className="card-body"
          >
            <div className="card-product-title">{Fname}</div>
            {Bname && <div className="card-product-brand">{Bname}</div>}
            <div
              style={{
                maxWidth: '230px',
              }}
              className="card-product-title"
            >
              {calculateItemPrice()}
            </div>
          </div>
        </div>
      </div>
      {/* {plus && ( */}
      {/* <div
        style={{
          position: 'absolute',
          marginLeft: '210px',
          marginTop: '-92px',
        }}
      >
        <PlusSign
          onClick={() => {
            cartAnimation(true, '.giftsvg-p');
            addToCart();
          }}
          height={35}
          id="Plus_sign_black"
          className="svg-style-color"
        />
      </div> */}
      {/* )} */}
    </div>
  ) : (
    <div>
      <div
        className="mb-5 ml-1 mr-1 category-card"
        style={{
          paddingLeft: '15px',
          paddingRight: '15px',
          boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)',
          overflow: 'hidden',
          position: 'relative',
          height: '340px',
        }}
      >
        {products[i].current_stock == 0 && (
          <div
            className="out_of_stock_container_p2"
            onClick={() => history.push(`/machineUI/product/${props.machineID}/${props.id}/${i}`)}
          >
            <div className="category-card out_of_stock_div"></div>
            <div className="out_of_stock_text_p2 d-flex flex-column justify-content-center align-items-center">
              <p style={{ marginBottom: '-10px' }}>{t(`Out of`)}</p>
              <p>{t(`Stock`)}</p>
            </div>
          </div>
        )}
        <div
          onClick={() => history.push(`/machineUI/product/${props.machineID}/${props.id}/${i}`)}
          style={{
            textDecoration: 'none',
            color: 'inherit',
          }}
        >
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              height: '240px',
              border: 'none',
              borderRadius: '1em',
              borderBottom: 'none',
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
            }}
          >
            <img
              style={{
                maxHeight: '80%',
                maxWidth: '90%',
              }}
              src={props.image}
              alt={props.imagename}
            />
          </div>
          <div
            style={{
              paddingBottom: '0',
              paddingTop: '0.5rem',
            }}
            className="card-body"
          >
            <div className="card-product-title">{Fname}</div>
            {Bname && <div className="card-product-brand">{Bname}</div>}
            <div
              style={{
                maxWidth: '230px',
              }}
              className="card-product-title"
            >
              {calculateItemPrice()}
            </div>
          </div>
        </div>
      </div>
      {/* {plus && (
        <div
          style={{
            position: 'absolute',
            marginLeft: '320px',
            marginTop: '-105px',
          }}
        >
          <PlusSign
            onClick={() => {
              cartAnimation(true, '.giftsvg-p');
              addToCart();
            }}
            height={45}
            id="Plus_sign_black"
            className="svg-style-color"
          />
        </div>
      )} */}
    </div>
  );
}
